import { Link } from "react-router-dom";
import { isAgentPortal, isFlagEnabled } from "js/utilities";
import { Trans, useTranslation } from "react-i18next";
export default function GuestServicesCard({
  setOpenChatWindow,
  hideCustomChat,
}) {
  const { t } = useTranslation();
  return (
    <div className="ui-card text-center p-4 relative xl:p-6">
      <h2>{t("AgentGuestServices-title")}</h2>
      <p className="text-sm mb-6">{t("AgentGuestServices-subtitle")}</p>
      <div className="w-40 px-2 mx-auto">
        {isAgentPortal() ? (
          <>
            {!hideCustomChat && (
              <div className="mb-6">
                <button
                  className="ui-btn-primary block w-full"
                  onClick={() => setOpenChatWindow((open) => !open)}
                >
                  {t("AgentGuestServices-button-2")}
                </button>
              </div>
            )}

            <p className="text-xs w-40 leading-snug">
              <Trans
                i18nKey="AgentGuestServices-links"
                components={{
                  link1: <Link to="/help/faqs"></Link>,
                  link2: <Link to="/help"></Link>,
                }}
              ></Trans>
            </p>
          </>
        ) : (
          <>
            <div className="mb-6">
              <Link
                to="/guest/claims/file-a-claim"
                className="ui-btn-primary block w-full"
              >
                {t("CustomerGuestServices-button")}
              </Link>
            </div>
            <div className="mb-6">
              <Link
                to="/guest/make-a-payment"
                className="ui-btn-primary block w-full"
              >
                {t("CustomerGuestServices-button-2")}
              </Link>
            </div>

            {isFlagEnabled("ENABLE_CUSTOMER_PORTAL_CHAT_FUNCTION") && (
              <div className="mb-6">
                <button
                  className="ui-btn-primary block w-full"
                  onClick={() => setOpenChatWindow((open) => !open)}
                >
                  {t("CustomerGuestServices-button-4")}
                </button>
              </div>
            )}

            <p className="text-xs w-40 leading-snug">
              <Trans
                i18nKey="AgentGuestServices-links"
                components={{
                  link1: <Link to="/guest/help/help-faqs"></Link>,
                  link2: <Link to="/guest/help"></Link>,
                }}
              ></Trans>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
